import { getTextFieldIconByStatus } from '@opengov/capital-mui-theme';
import { useMemo, useState } from 'react';
import { Folder } from '../../../types';
import { intl } from '../FolderTitleInput';

type UseFolderTitleProps = {
  isCreatingFolder: boolean;
  folders: Folder[];
};

export const useFolderTitle = ({ isCreatingFolder, folders }: UseFolderTitleProps) => {
  const [error, setError] = useState<string | null>(null);
  const [folderTitle, setFolderTitle] = useState(intl.defaultTitle);

  const trimmedFolderTitle = useMemo(() => folderTitle.trim(), [folderTitle]);
  const isFolderTitleUnique = useMemo(() => {
    return !folders.find((folder) => folder.title === trimmedFolderTitle);
  }, [trimmedFolderTitle, folders]);

  const isCreateDisabled = useMemo(
    () => isCreatingFolder || trimmedFolderTitle.length === 0 || !isFolderTitleUnique,
    [trimmedFolderTitle, isFolderTitleUnique, isCreatingFolder]
  );

  const helperTextWithIcon = useMemo(() => {
    const helperText = !isFolderTitleUnique ? intl.uniqueNameValidationError : error;
    return helperText ? [getTextFieldIconByStatus('error') as JSX.Element, helperText] : undefined;
  }, [isFolderTitleUnique, error]);

  return {
    folderTitle,
    setFolderTitle,
    trimmedFolderTitle,
    isFolderTitleUnique,
    isCreateDisabled,
    helperTextWithIcon,
    error: Boolean(helperTextWithIcon),
    setError
  };
};
